import React from 'react';
import { Link } from "react-router-dom";
import { strings } from '../../components/utils/translations'

const GaragesIcon = (props) => {

  const { size, color, className, textClassName, onClick } = props;

  return (
    <Link to="/garages">
        <div className={className} onClick={onClick}>
            <svg version="1.1" width={size} viewBox="0 0 312.285 268.39" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.2049 268.31C18.9999 268.31 24.4898 262.82 24.4898 256.105L24.4898 31.2948C24.4898 27.1598 27.1598 24.4898 31.0673 24.4898L281.217 24.4898C285.125 24.4898 287.795 27.1598 287.795 31.2948L287.795 256.105C287.795 262.82 293.285 268.31 299.977 268.31C306.795 268.31 312.285 262.82 312.285 256.105L312.285 29.0324C312.285 11.4425 300.66 0 282.637 0L29.5674 0C11.625 0 0 11.4425 0 29.0324L0 256.105C0 262.82 5.48996 268.31 12.2049 268.31Z" fill={color} fillOpacity="0.5"/>
                <path d="M43.4323 94.4997L268.852 94.4997C271.115 94.4997 272.922 92.6922 272.922 90.5322L272.922 43.3523C272.922 41.0673 271.115 39.2598 268.852 39.2598L43.4323 39.2598C41.1698 39.2598 39.3623 41.0673 39.3623 43.3523L39.3623 90.5322C39.3623 92.6922 41.1698 94.4997 43.4323 94.4997ZM131.367 73.5272C127.472 73.5272 124.782 70.7123 124.782 66.9198C124.782 63.0248 127.472 60.2323 131.367 60.2323L180.917 60.2323C184.812 60.2323 187.502 63.0248 187.502 66.9198C187.502 70.7123 184.812 73.5272 180.917 73.5272Z" fill={color}/>
            </svg>

            <div className={textClassName} style={{ color: color }}>{ strings('garages') }</div>
        </div>
    </Link>
    );
}

export default GaragesIcon;
